import React from 'react'
import { useNode } from '@craftjs/core'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { HeadingSize } from './typings'

import type { IHeading as HeadingInterface } from './typings'

const Heading = ({ text, size = HeadingSize.MD }: HeadingInterface) => {
  const {
    connectors: { connect, drag },
    isSelected,
  } = useNode((node) => ({
    isSelected: node.events.selected,
  }))

  return (
    <Text
      // @ts-expect-error
      ref={(ref) => connect(drag(ref!))}
      className={clsx(
        'widget-component',
        'mb-2 last:mb-0',
        isSelected && 'widget-component__selected'
      )}
      variant={size}
    >
      {text}
    </Text>
  )
}

export default Heading
